import React from "react"
import { Col as AntdCol } from "antd"
import type { ColProps } from "antd/lib/col"

export const Col = ({ children, ...props }: ColProps): JSX.Element => {
  return <AntdCol {...props}>{children}</AntdCol>
}
